import { Volume2 } from "lucide-react";
import { t } from "@/i18n";

/* Fiche d'une lettre — même composant utilisé partout où l'app montre une
   lettre en détail : écran de découverte (PracticeAlphabet, Daily Plan) et
   fiche d'indice pendant le quiz. Une seule source pour ne jamais diverger. */
export default function LetterCard({ letter, onAudio }) {
  if (!letter) return null;
  return (
    <div className="text-center">
      <div
        className="arabic text-6xl sm:text-8xl leading-none mb-2 sm:mb-3"
        dir="rtl"
      >
        {letter.char}
      </div>
      <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
        <span className="text-lg sm:text-xl font-bold">{letter.name}</span>
        {onAudio && (
          <button
            type="button"
            onClick={() => onAudio("letter", letter.char)}
            className="w-8 h-8 rounded-full border grid place-items-center hover:bg-secondary transition shrink-0"
            aria-label={t("lettercard.ecouter_la_lettre")}
          >
            <Volume2 size={15} />
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-2 text-left">
        <div className="rounded-xl bg-secondary/50 p-2.5 sm:p-3">
          <div className="text-[10px] uppercase font-bold text-muted-foreground">
            {t("lettercard.nom")}
          </div>
          <div className="font-semibold text-sm sm:text-base">
            {letter.name}
          </div>
        </div>
        <div className="rounded-xl bg-secondary/50 p-2.5 sm:p-3">
          <div className="text-[10px] uppercase font-bold text-muted-foreground">
            {t("lettercard.son")}
          </div>
          <div className="font-semibold text-sm sm:text-base">
            {letter.sound || letter.translit}
          </div>
        </div>
      </div>
      {letter.hint && (
        <p className="text-xs sm:text-sm text-muted-foreground mt-2 sm:mt-3 leading-snug">
          {letter.hint}
        </p>
      )}
    </div>
  );
}
